
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';
import { Doughnut } from 'vue-chartjs';

@Component({})
export default class DoughnutChart extends Mixins(Doughnut) {
  @Prop(Array)
  private data!: Array<{
    label: string;
    value: number;
    color: string;
  }>;

  private chartData: Chart.ChartData = {
    labels: this.data.map(d => d.label),
    datasets: [
      {
        data: this.data.map(d => d.value),
        backgroundColor: this.data.map(d => d.color),
      },
    ],
  };
  private chartOptions: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  };

  private mounted() {
    // グラフを描画
    this.renderChart(this.chartData, this.chartOptions);
  };

  @Watch('data')
  private onChangeData() {
    if (this.chartData.datasets) {
      this.chartData.labels = this.data.map(d => d.label);
      this.chartData.datasets[0].data = this.data.map(d => d.value);
      this.chartData.datasets[0].backgroundColor = this.data.map(d => d.color);
      // グラフを描画
      this.renderChart(this.chartData, this.chartOptions);
    }
  }
}
